module.exports = __webpack_public_path__ + "static/img/acne-01.196b2bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/acne-01.jpg
// module id = 241
// module chunks = 1